module.exports = __webpack_public_path__ + "img/flag-afrikaans.b9f01b11.jpg";